import { Layout, Menu } from 'antd';
import {
  ShoppingOutlined,
} from '@ant-design/icons';

import logo from '@/assets/img/primepass-logo.svg';
import logoIcon from '@/assets/img/primepass-icon.png';

import { Logo } from './styles';

const { Sider } = Layout;

interface SidebarProps {
  open: boolean;
}

export default function Sidebar({ open }: SidebarProps) {
  return (
    <Sider
      trigger={null}
      collapsible
      collapsed={open}
      style={{
        overflow: 'auto',
        height: '100vh',
        position: 'sticky',
        top: 0,
        left: 0,
      }}
    >
      <Logo>
        {!open ? (
          <img src={logo} alt="primepass" width={100} />
        ) : (
          <img src={logoIcon} alt="primepass" width={20} />
        )}
      </Logo>
      <Menu
        theme="dark"
        mode="inline"
        defaultSelectedKeys={['1']}
        items={[
          {
            key: '1',
            icon: <ShoppingOutlined />,
            label: 'Vendas',
          },
        ]}
      />
    </Sider>
  );
}
